const hostname = window.location.hostname;
const port = window.location.port * 1;
const protocol = window.location.protocol;

const isProduction = hostname === 'orm.bailac.net';

const fronurl = `${protocol}//${hostname}`;
const backurl = isProduction ? `${protocol}//${hostname}/orm/` : `${protocol}//${hostname}:${port + 1}/orm/`;
const apiurl = isProduction ? `${protocol}//${hostname}/orm/api/` : `http://${hostname}:${port + 1}/orm/api/`;
const wsurl = isProduction ? `wss://${hostname}/ws/item` : `ws://${hostname}:${port + 3}/ws/item`;;

export { fronurl, backurl, apiurl, wsurl };